import { useNotification } from '@/_shared/mixins';

export const useMenuMessenger = {
  mixins: [useNotification],
  methods: {
    hasUnclosedShiftsMessage(responseData = {}) {
      if (!responseData.message) {
        return;
      }
      const messagePattern = /незавершенные смены/gi;
      const { message } = responseData;
      if (messagePattern.test(message)) {
        this.showWarningNotification(message);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/work-shift-menu/useMenuMessenger.js